import { Directive, type OnInit } from '@angular/core';
import { type ControlValueAccessor } from '@angular/forms';
import { BaseDelegatedFormControlComponent } from './base-delegated-form-control.component';

/**
 * Base class for reactive value accessors.
 *
 * Useful when using additional components with form control directives within the value accessor component.
 * Since we delegate the value accessor, there's no need to separately implement the `ControlValueAccessor` interface
 * in the child class, as the binding will provide it.
 * In the child component, work with the form control reference stored in `delegatedControl`.
 */
@Directive({})
export abstract class AbstractDelegatedFormControlComponent<T>
  extends BaseDelegatedFormControlComponent<T>
  implements ControlValueAccessor, OnInit
{
  override ngOnInit(): void {
    super.ngOnInit();
    this.ngControl.valueAccessor = this;
  }

  writeValue(): void {}

  registerOnChange(): void {}

  registerOnTouched(): void {}
}
